import React, { useState, useEffect } from "react";
import apiService from "../services/apiService";
import "./css/Dashboard.css";

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        setLoading(true);
        const data = await apiService.getDashboardStats();
        setStats(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching dashboard stats:", err);
        setError("Failed to load dashboard statistics.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, []);

  if (loading) {
    return (
      <div>
        <h1>Dashboard</h1>
        <p>Loading dashboard statistics...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1>Dashboard</h1>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  if (!stats) {
    return (
      <div>
        <h1>Dashboard</h1>
        <p>No statistics available.</p>
      </div>
    );
  }

  const mainStats = [
    { label: "Total Courses", value: stats.total_courses, icon: "📚", color: "#4299e1" },
    { label: "Uploaded Lessons", value: stats.uploaded_lessons, icon: "📝", color: "#48bb78" },
    { label: "Question Sets", value: stats.quizzes_generated, icon: "❓", color: "#ed8936" },
    { label: "AI Chats", value: stats.ai_chats, icon: "💬", color: "#9f7aea" }
  ];

  const aiBreakdownItems = [
    { 
      label: "Summarization", 
      value: stats.ai_chats_breakdown?.summarization || 0, 
      icon: "📄",
      color: "#4299e1"
    },
    { 
      label: "Transcription", 
      value: stats.ai_chats_breakdown?.transcription || 0, 
      icon: "🎙️",
      color: "#ed8936"
    },
    { 
      label: "Question Set Generation", 
      value: stats.ai_chats_breakdown?.question_generation || 0, 
      icon: "❓",
      color: "#48bb78"
    },
    { 
      label: "Question Enhancement", 
      value: stats.ai_chats_breakdown?.question_enhancement || 0, 
      icon: "✨",
      color: "#9f7aea"
    }
  ];

  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>
      
      <div className="resources-section">
        <div className="section-header">
          <h2>Resources Overview</h2>
          <p className="section-subtitle">Summary of your learning content and generated materials</p>
        </div>
        <div className="stats-grid">
          {mainStats.map((s, i) => (
            <div key={i} className="stat-card">
              <div className="stat-icon" style={{ fontSize: '2.5rem' }}>{s.icon}</div>
              <div className="stat-number" style={{ color: s.color }}>{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {stats.ai_chats_breakdown && (
        <div className="ai-usage-section">
          <div className="section-header">
            <h2>AI Usage Breakdown</h2>
            <p className="section-subtitle">Detailed breakdown of your AI interactions</p>
          </div>
          <div className="ai-breakdown-grid">
            {aiBreakdownItems.map((item, i) => (
              <div key={i} className="ai-breakdown-card">
                <div className="ai-card-header">
                  <span className="ai-card-icon" style={{ backgroundColor: `${item.color}20`, color: item.color }}>
                    {item.icon}
                  </span>
                  <span className="ai-card-value" style={{ color: item.color }}>{item.value}</span>
                </div>
                <div className="ai-card-label">{item.label}</div>
                <div className="ai-card-progress">
                  <div 
                    className="ai-card-progress-bar" 
                    style={{ 
                      width: `${stats.ai_chats > 0 ? (item.value / stats.ai_chats * 100) : 0}%`,
                      backgroundColor: item.color
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
